export default "__VITE_ASSET__Dtw1j8q4__"